import Cookies from 'js-cookie'

const TokenKey = 'wurong_token'
export const StorageUserInfoKey = 'wurong'
export function storageSetItem(key, data) {
  if (key) {
    sessionStorage.setItem(key, data)
  }
}
export function storageGetItem(key) {
  return sessionStorage.getItem(key)
}
export function storageRemoveItem(key) {
  return sessionStorage.getItem(key)
}
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  storageRemoveItem(StorageUserInfoKey)
  return Cookies.remove(TokenKey)
}
